import { useParams } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { Settings } from 'lucide-react'

export default function TeamSettingsPlaceholder() {
  const { id } = useParams<{ id: string }>()

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <header className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Settings className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Team settings</h1>
            <p className="text-muted-foreground">Configuration UI will be ported soon.</p>
          </div>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>Coming soon</CardTitle>
            <CardDescription>
              Bring the settings panels from the Next.js dashboard to manage notification rules and member roles here.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button asChild>
              <Link to={`/dashboard/team/${id}`}>Back to team overview</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
